import { render, staticRenderFns } from "./StatusTable.vue?vue&type=template&id=83d22560&"
import script from "./StatusTable.vue?vue&type=script&lang=js&"
export * from "./StatusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports